import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Testimonials = () => {
  return (
    <section id="testimonials" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Avis <span className="text-blue-600">clients</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            La satisfaction de nos clients est au cœur de notre métier
          </p>
        </div>

        {/* Testimonials Coming Soon */}
        <div className="max-w-4xl mx-auto">
          <Card className="border-2 border-gray-200 bg-gray-50">
            <CardContent className="p-12 text-center">
              <div className="flex justify-center mb-6">
                <div className="bg-blue-100 rounded-full p-4">
                  <Quote className="w-12 h-12 text-blue-600" />
                </div>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">
                Vos avis comptent
              </h3>
              <p className="text-gray-600 mb-6 max-w-xl mx-auto leading-relaxed">
                Nous collectons actuellement les retours de nos clients. 
                Cette section sera prochainement enrichie avec leurs témoignages et avis détaillés.
              </p>
              <p className="text-sm text-gray-500 italic">
                Artisan à l'écoute, travail soigné et finitions de qualité depuis 1992
              </p>
            </CardContent>
          </Card>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-600 mb-2">33 ans</div>
            <p className="text-gray-600">Années d'expérience</p>
            <p className="text-sm text-gray-500 mt-1">Depuis 1992</p>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-blue-600 mb-2">50 km</div>
            <p className="text-gray-600">Zone d'intervention</p>
            <p className="text-sm text-gray-500 mt-1">Lyon • Brignais • Monts du Lyonnais</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
